const DEFAULT_LOCAL_CURRENCY = 'BRL';

export function normalizeProductCurrency(currency) {
  if (currency != null && String(currency).trim() !== '') {
    return String(currency).trim().toUpperCase();
  }

  return DEFAULT_LOCAL_CURRENCY;
}

export function isLocalCurrency(currency) {
  return normalizeProductCurrency(currency) === DEFAULT_LOCAL_CURRENCY;
}
